import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SisColValueComponent } from '@smartera/components';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderModule, RecordsNotFoundModule } from '@shared/components';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { SmartyGptComponent } from './components/smarty-gpt.component';
import { SmartyGptService } from './services/smarty-gpt.service';

@NgModule({
	declarations: [SmartyGptComponent],
	imports: [
		CommonModule,
		FormsModule,

		SisColValueComponent,
		RecordsNotFoundModule,
		LoaderModule,

		ButtonModule,
		TableModule,
		InputTextModule,
		TranslateModule,
		CardModule,
	],
	exports: [SmartyGptComponent],
	providers: [SmartyGptService],
})
export class SmartyGptModule {}
